module.exports = __webpack_public_path__ + "img/drawer.c0f8ee04.svg";